import styled from '@emotion/styled';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

export const FilterBar = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center',
  gap: '16px',
});

export const ScrollableContent = styled(Box)({
  flex: 1,
  overflowY: 'auto',
  marginLeft: '-24px',
  marginRight: '-24px',
  '&::-webkit-scrollbar': { width: 6 },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'transparent',
    borderRadius: 3,
    transition: 'background-color 0.3s',
  },
  '&:hover::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(0,0,0,0.2)',
  },
  scrollbarWidth: 'thin',
  scrollbarColor: 'transparent transparent',
  '&:hover': {
    scrollbarColor: 'rgba(0,0,0,0.2) transparent',
  },
});
